"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LOAD_PRODUCT_GROUPS = 'LOAD_PRODUCT_GROUPS';
exports.LOAD_PRODUCT_GROUP = 'LOAD_PRODUCT_GROUP';
exports.CREATE_PRODUCT_GROUP = 'CREATE_PRODUCT_GROUP';
exports.UPDATE_PRODUCT_GROUP = 'UPDATE_PRODUCT_GROUP';
exports.PUBLISH_PRODUCT_GROUP = 'PUBLISH_PRODUCT_GROUP';
exports.ADD_PRODUCT_GROUP_PERMISSION = 'ADD_PRODUCT_GROUP_PERMISSION';
exports.REMOVE_PRODUCT_GROUP_PERMISSION = 'REMOVE_PRODUCT_GROUP_PERMISSION';
exports.SET_PRODUCT_GROUP_ACCESSIBILITY = 'SET_PRODUCT_GROUP_ACCESSIBILITY';
exports.SET_PRODUCTGROUP_ORGANIZATION = 'SET_PRODUCTGROUP_ORGANIZATION';
exports.ADD_PRODUCTGROUP_RELATION = 'ADD_PRODUCTGROUP_RELATION';
exports.REMOVE_PRODUCTGROUP_RELATION = 'REMOVE_PRODUCTGROUP_RELATION';
exports.LOAD_PUBLIC_PRODUCT_GROUPS = 'LOAD_PUBLIC_PRODUCT_GROUPS';
exports.LOAD_PUBLIC_PRODUCT_GROUP = 'LOAD_PUBLIC_PRODUCT_GROUP';
exports.LOAD_PRODUCTS = 'LOAD_PRODUCTS';
exports.LOAD_PRODUCT = 'LOAD_PRODUCT';
exports.CREATE_PRODUCT = 'CREATE_PRODUCT';
exports.UPDATE_PRODUCT = 'UPDATE_PRODUCT';
exports.PUBLISH_PRODUCT = 'PUBLISH_PRODUCT';
exports.UNPUBLISH_PRODUCT = 'UNPUBLISH_PRODUCT';
exports.DISCONTINUE_PRODUCT = 'DISCONTINUE_PRODUCT';
exports.ADD_PRODUCT_PERMISSION = 'ADD_PRODUCT_PERMISSION';
exports.REMOVE_PRODUCT_PERMISSION = 'REMOVE_PRODUCT_PERMISSION';
exports.SET_PRODUCT_ACCESSIBILITY = 'SET_PRODUCT_ACCESSIBILITY';
exports.SET_PRODUCT_ORGANIZATION = 'SET_PRODUCT_ORGANIZATION';
exports.ADD_PRODUCT_RELATION = 'ADD_PRODUCT_RELATION';
exports.REMOVE_PRODUCT_RELATION = 'REMOVE_PRODUCT_RELATION';
exports.LOAD_PUBLIC_PRODUCTS = 'LOAD_PUBLIC_PRODUCTS';
exports.LOAD_PUBLIC_PRODUCT = 'LOAD_PUBLIC_PRODUCT';
exports.LOAD_PRODUCT_PROPERTIES = 'LOAD_PRODUCT_PROPERTIES';
exports.LOAD_PRODUCT_PROPERTY = 'LOAD_PRODUCT_PROPERTY';
exports.CREATE_PRODUCT_PROPERTY = 'CREATE_PRODUCT_PROPERTY';
exports.UPDATE_PRODUCT_PROPERTY = 'UPDATE_PRODUCT_PROPERTY';
exports.ADD_PRODUCT_PROPERTY_PERMISSION = 'ADD_PRODUCT_PROPERTY_PERMISSION';
exports.REMOVE_PRODUCT_PROPERTY_PERMISSION = 'REMOVE_PRODUCT_PROPERTY_PERMISSION';
exports.SET_PRODUCT_PROPERTY_ACCESSIBILITY = 'SET_PRODUCT_PROPERTY_ACCESSIBILITY';
exports.SET_PRODUCTPROPERTY_ORGANIZATION = 'SET_PRODUCTPROPERTY_ORGANIZATION';
exports.ADD_PRODUCTPROPERTY_RELATION = 'ADD_PRODUCTPROPERTY_RELATION';
exports.REMOVE_PRODUCTPROPERTY_RELATION = 'REMOVE_PRODUCTPROPERTY_RELATION';
exports.LOAD_PUBLIC_PRODUCT_PROPERTIES = 'LOAD_PUBLIC_PRODUCT_PROPERTIES';
exports.LOAD_PUBLIC_PRODUCT_PROPERTY = 'LOAD_PUBLIC_PRODUCT_PROPERTY';
exports.LOAD_REVIEW_GROUPS = 'LOAD_REVIEW_GROUPS';
exports.LOAD_REVIEW_GROUP = 'LOAD_REVIEW_GROUP';
exports.CREATE_REVIEW_GROUP = 'CREATE_REVIEW_GROUP';
exports.UPDATE_REVIEW_GROUP = 'UPDATE_REVIEW_GROUP';
exports.PUBLISH_REVIEW_GROUP = 'PUBLISH_REVIEW_GROUP';
exports.ADD_REVIEW_GROUP_PERMISSION = 'ADD_REVIEW_GROUP_PERMISSION';
exports.REMOVE_REVIEW_GROUP_PERMISSION = 'REMOVE_REVIEW_GROUP_PERMISSION';
exports.SET_REVIEW_GROUP_ACCESSIBILITY = 'SET_REVIEW_GROUP_ACCESSIBILITY';
exports.SET_REVIEWGROUP_ORGANIZATION = 'SET_REVIEWGROUP_ORGANIZATION';
exports.ADD_REVIEWGROUP_RELATION = 'ADD_REVIEWGROUP_RELATION';
exports.REMOVE_REVIEWGROUP_RELATION = 'REMOVE_REVIEWGROUP_RELATION';
exports.LOAD_PUBLIC_REVIEW_GROUPS = 'LOAD_PUBLIC_REVIEW_GROUPS';
exports.LOAD_PUBLIC_REVIEW_GROUP = 'LOAD_PUBLIC_REVIEW_GROUP';
exports.LOAD_REVIEWS = 'LOAD_REVIEWS';
exports.LOAD_REVIEW = 'LOAD_REVIEW';
exports.CREATE_REVIEW = 'CREATE_REVIEW';
exports.UPDATE_REVIEW = 'UPDATE_REVIEW';
exports.PUBLISH_REVIEW = 'PUBLISH_REVIEW';
exports.UNPUBLISH_REVIEW = 'UNPUBLISH_REVIEW';
exports.DISCONTINUE_REVIEW = 'DISCONTINUE_REVIEW';
exports.ADD_REVIEW_PERMISSION = 'ADD_REVIEW_PERMISSION';
exports.REMOVE_REVIEW_PERMISSION = 'REMOVE_REVIEW_PERMISSION';
exports.SET_REVIEW_ACCESSIBILITY = 'SET_REVIEW_ACCESSIBILITY';
exports.SET_REVIEW_ORGANIZATION = 'SET_REVIEW_ORGANIZATION';
exports.ADD_REVIEW_RELATION = 'ADD_REVIEW_RELATION';
exports.REMOVE_REVIEW_RELATION = 'REMOVE_REVIEW_RELATION';
exports.LOAD_PUBLIC_REVIEWS = 'LOAD_PUBLIC_REVIEWS';
exports.LOAD_PUBLIC_REVIEW = 'LOAD_PUBLIC_REVIEW';